<template>
  <div id="grid-validacion">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="validacionesHistorico"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.area }}</td>
              <td class="text-xs-left">{{ props.item.observacion }}</td>
              <td class="text-xs-left">{{ props.item.estadoValidacion }}</td>
              <td class="text-xs-left">{{ props.item.usuario }}</td>
              <td class="text-xs-left">{{ props.item.fecha }}</td>
              <v-btn
                v-if="
                  props.item.filename != null &&
                  props.item.filename != '' &&
                  props.item.filename !== undefined
                "
                depressed
                outline
                title="Descargar documento"
                icon
                fab
                dark
                color="primary"
                small
                @click="downloadFile(props.item.id, props.item.filename)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "grid-validacion-historico",
  components: {},
  props: {
    idValidacion: "",
    idRolArea: "",
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      dialog: false,
      rowsPerPageItems: [20],
      validaciones: [],
      documentoId: "",
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Area",
          align: "left",
          sortable: false,
          value: "area",
        },
        { text: "Observacion", sortable: false, value: "observacion" },
        { text: "Estado", sortable: false, value: "estadoValidacion" },
        { text: "Usuario", sortable: false, value: "usuario" },
        {
          text: "Fecha Ult. Actualizacion",
          sortable: false,
          value: "fechaActualizacion",
        },
        { text: "Accion", sortable: false, value: "documento" },
      ],
      validacionesHistorico: [],
    };
  },
  created() {
    this.idValidacion = this.$route.params.idValidacion;
    this.idRolArea = this.$route.params.idRolArea;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadDataValidacionHistorico();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDataValidacionHistorico() {
      this.loading = true;
      this.validacionesHistorico =
        await this.loadValidatesHistoricoByContract();
      this.loading = false;
    },

    async loadValidatesHistoricoByContract() {
      return await axios
        .get(
          "/validaciones/historico/subitem/" +
            this.idValidacion +
            "/rol/" +
            this.idRolArea +
            "/contrato/" +
            this.idContrato
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    downloadFile(id, filename) {
      let that = this;
      axios({
        url: "/validaciones/download/historico/" + id,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
